import React, { Component, SyntheticEvent, useState } from 'react';
import '../Login.css';
import logos from "../bootstrap-logo.svg"
import axios from "axios"
import profile from "../assets/images/verification-img.png";
import logo from "../assets/images/logo.svg";
import { useNavigate, Link } from 'react-router-dom';

import {
    Row,
    Col,
    CardBody,
    Card,
    Container,
    Form,
} from "reactstrap";
const Register = () => {

    const navigate = useNavigate();
    const [first_name, setFirst_name] = useState('');
    const [last_name, setLast_name] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password_confirm, setPassword_confirm] = useState('');
    const [redirect, setRedirect] = useState(false);
    const submit = async (event: SyntheticEvent) => {
        event.preventDefault();
        const formData = {
            first_name,
            last_name,
            email,
            password,
            password_confirm,
        }
        const url = 'register'
        try {
            const response = await axios.post(url, formData);
            setRedirect(true);
            if (redirect) {
                return navigate('/');
            }
        } catch (error) {
            console.error('Error:', error); // Maneja errores aquí
        }
    }
    return (
        // <main className="form-signin w-100 m-auto">
        // {/* <form onSubmit={this.submit}> */}
        // <form onSubmit={submit}>
        //     <img className="mb-4" src={logo} alt="" width="72" height="57"/>
        //     <h1 className="h3 mb-3 fw-normal">Registrarse</h1>
        //     <div className="form-floating">
        //         <input type="string" className="form-control" id="first_name" placeholder="Fist Name" required
        //             onChange={event => setFirst_name(event.target.value)}/>
        //         <label htmlFor="first_name">First Name</label>
        //     </div>
        //     <div className="form-floating">
        //         <input type="string" className="form-control" id="last_name" placeholder="Last Name" required
        //         onChange={event => setLast_name(event.target.value)} />
        //         <label htmlFor="last_name">Last Name</label>
        //     </div>
        //     <div className="form-floating">
        //         <input type="email" className="form-control" id="email" placeholder="Email" required
        //         onChange={event => setEmail(event.target.value)}/>
        //         <label htmlFor="email">Email</label>
        //     </div>
        //     <div className="form-floating">
        //         <input type="password" className="form-control" id="password" placeholder="Password" required
        //         onChange={event => setPassword(event.target.value)}/>
        //         <label htmlFor="password">Password</label>
        //     </div>
        //     <div className="form-floating">
        //         <input type="password" className="form-control" id="password_confirm" placeholder="Password Confirm" 
        //         required onChange={event => setPassword_confirm(event.target.value)}/>
        //         <label htmlFor="password_confirm">Password Confirm</label>
        //     </div>

        //     <button className="btn btn-primary w-100 py-2" type="submit">Registrar</button>
        //     <p className="mt-5 mb-3 text-body-secondary">&copy; 2017–2023</p>
        // </form>
        // </main>  
        <React.Fragment>
            <div className="home-btn d-none d-sm-block">
                <Link to="/" className="text-dark">
                    <i className="bx bx-home h2" />
                </Link>
            </div>
            <div className="account-pages my-5 pt-sm-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="overflow-hidden">
                                <div className="bg-primary-subtle">
                                    <Row>
                                        <Col xs={7}>
                                            <div className="text-primary p-4">
                                                <h5 className="text-primary">Registro Gratuito!</h5>
                                                <p>Cree su cuenta ahora.</p>
                                            </div>
                                        </Col>
                                        <Col className="col-5 align-self-end">
                                            <img src={profile} alt="" className="img-fluid" />
                                        </Col>
                                    </Row>
                                </div>
                                <CardBody className="pt-0">
                                    <div style={{ height: "95%", width: "95%" }}>
                                        <Link to="/" className="auth-logo-light">
                                            <div className="avatar-md profile-user-wid mb-4">
                                                <span className="avatar-title rounded-circle bg-light">
                                                </span>
                                            </div>
                                        </Link>
                                    </div>
                                    <div className="p-2">

                                        <Form classNa me="form-horizontal" onSubmit={submit}>
                                            <div className="mb-3">
                                                <label htmlFor="first_name">First Name</label>
                                                <input type="string" className="form-control" id="first_name" autoComplete="off" placeholder="Fist Name" required
                                                    onChange={event => setFirst_name(event.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="last_name">Last Name</label>
                                                <input type="string" className="form-control" id="last_name" autoComplete="off" placeholder="Last Name" required
                                                    onChange={event => setLast_name(event.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="email">Email</label>
                                                <input type="email" className="form-control" id="email" autoComplete="off" placeholder="Email" required
                                                    onChange={event => setEmail(event.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="password">Password</label>
                                                <input type="password" className="form-control" id="password" autoComplete="off" placeholder="Password" required
                                                    onChange={event => setPassword(event.target.value)} />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="password_confirm">Password Confirm</label>
                                                <input type="password" className="form-control" id="password_confirm" autoComplete="off" placeholder="Password Confirm"
                                                    required onChange={event => setPassword_confirm(event.target.value)} />
                                            </div>
                                            <div className="mt-3 d-grid">

                                                <button className="btn btn-primary btn-block" type="submit">Crear Cuenta</button>

                                            </div>
                                        </Form>
                                    </div>

                                </CardBody>
                            </Card>
                            <div className="mt-5 text-center">
                                <p>
                                    Ya tienes cuenta?{" "}
                                    <Link to="/login" className="fw-medium text-primary">
                                        {" "}
                                        Inicia Sesión{" "}
                                    </Link>{" "}
                                </p>
                                <p>
                                    © {new Date().getFullYear()} Creado por {" "}
                                    <i className="mdi mdi-heart text-danger" /> Routes App Team
                                </p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment >
    )
}

export default Register;